import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { LanguageSelectionModal } from '~shared-components/components/Modal/LanguageSelectionModal'
import { useAllowedLanguages } from '~shared-components/hooks/useAllowedLanguages'
import { TranslationsSelector } from '~shared-components/redux/selectors/translations.selector'
import { SupportedLanguage } from '~shared-components/utils/enums'

import { LanguageDropdown } from './LanguageDropdown'

interface LanguageSelectionProps {
  isLoading?: boolean
  onChange: (language: SupportedLanguage) => Promise<void> | void
  placement?: 'top' | 'bottom'
  showOnlyCommonLanguage?: boolean
  showWhenOnlyOneLanguage?: boolean
}

export const LanguageSelection = ({
  isLoading = false,
  onChange,
  placement = 'bottom',
  showOnlyCommonLanguage,
  showWhenOnlyOneLanguage,
}: LanguageSelectionProps) => {
  const allowedLanguages = useAllowedLanguages({ showOnlyCommonLanguage })
  const currentLanguage = useSelector(TranslationsSelector.currentLanguage)
  const [isOpen, setIsOpen] = useState(false)
  const [selectedLanguage, setSelectedLanguage] = useState<SupportedLanguage>(
    currentLanguage,
  )

  useEffect(() => {
    setSelectedLanguage(currentLanguage)
  }, [currentLanguage])

  if (!showWhenOnlyOneLanguage && allowedLanguages.length < 1) {
    return null
  }

  return (
    <>
      <LanguageDropdown
        onChange={language => {
          setSelectedLanguage(language)
          setIsOpen(true)
        }}
        placement={placement}
        value={selectedLanguage}
      />
      <LanguageSelectionModal
        isLoading={isLoading}
        isOpen={isOpen}
        onChange={async () => {
          await onChange(selectedLanguage)
          setIsOpen(false)
        }}
        onClose={() => {
          setIsOpen(false)
          setSelectedLanguage(currentLanguage)
        }}
      />
    </>
  )
}
